<template>
  <div class="WorkPositionTypePage contentBox">
    <div class="rightContent">
      <el-table
        stripe
        :data="positionTypeData"
        border
        style="width: 100%"
        height="100%"
        size="mini"
        @sort-change="sortChange"
      >
        <el-table-column
          type="index"
          width="50"
          align="center"
          :index="pagination.beginIndex"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="岗位类别"
          align="center"
          sortable="custom"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          class-name="operation"
          label="操作"
          align="center"
          width="105px"
        >
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="top"
              :open-delay="300"
            >
              <i @click="editPositionType(scope.row)" class="el-icon-edit"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="上移"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="moveUpPositionType($event, scope.row)"
                class="el-icon-arrow-up"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="下移"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="moveDownPositionType($event, scope.row)"
                class="el-icon-arrow-down"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              :open-delay="300"
            >
              <i
                @click="deletePositionType($event, scope.row)"
                class="el-icon-delete"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="getPositionTypeSearch"
      ></pagination>
    </div>
    <myDialog
      ref="positionTypeDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="岗位类别：" size="small" prop="name">
            <el-input
              v-model="dialogForm.name"
              placeholder="输入岗位类别名称"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiPositionTypeSearch,
  apiPositionTypeAdd,
  apiPositionTypeUpdate,
  apiPositionTypeMoveUp,
  apiPositionTypeMoveDown,
  apiPositionTypeDelete,
} from "@/api/userApi.js";
export default {
  props: {
    positionTypeSearchForm: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    pagination,
    myDialog,
  },
  data() {
    return {
      pullDownData: {
      },
      positionTypeData: [],
      orderBy: [],
      desc: undefined,
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        name: [
          { required: true, message: "名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 32,
            message: "长度在 2 到 32 个字符",
            trigger: "change"
          }
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    // 岗位类别-表格数据
    async getPositionTypeSearch(remove) {
      if (!(remove == "noRemove")) {
        this.positionTypeData = [];
      }
      const res = await apiPositionTypeSearch({
        ...this.positionTypeSearchForm,
        orderBy: this.orderBy,
        desc: this.desc,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      });
      // console.log(res);
      if (res.code == 0) {
        this.positionTypeData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // 添加岗位类别
    addPositionType() {
      this.dialogTitle = "添加岗位类别";
      this.$refs.positionTypeDialog.dialogVisible = true;
    },
    // 编辑岗位类别
    editPositionType(row) {
      this.dialogTitle = "修改岗位类别";
      this.$refs.positionTypeDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id,
        name: row.name
      };
    },
    // 上移岗位类别
    moveUpPositionType(e, row) {
      e.target.blur();
      this.$confirm(`是否上移【${row.name}】？`, "上移岗位类别", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiPositionTypeMoveUp({
          id: row.id,
        });
        if (res.code == 0) {
          this.getPositionTypeSearch("noRemove");
          this.$message({
            message: "上移成功",
            type: "success",
          });
        }
      });
    },
    // 下移岗位类别
    moveDownPositionType(e, row) {
      e.target.blur();
      this.$confirm(`是否下移【${row.name}】？`, "下移岗位类别", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiPositionTypeMoveDown({
          id: row.id,
        });
        if (res.code == 0) {
          this.getPositionTypeSearch("noRemove");
          this.$message({
            message: "下移成功",
            type: "success",
          });
        }
      });
    },
    // 删除岗位类别
    deletePositionType(e, row) {
      e.target.blur();
      this.$allOperation(row, "删除", "岗位类别").then(async () => {
        const res = await apiPositionTypeDelete({
          id: row.id,
        });
        if (res.code == 0) {
          this.getPositionTypeSearch("noRemove");
          this.$message({
            message: "删除成功",
            type: "success",
          });
        }
      });
    },
    // 确认添加
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "添加岗位类别") {
            const res = await apiPositionTypeAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.positionTypeDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getPositionTypeSearch();
              this.$message({
                message: "添加成功",
                type: "success",
              });
            }
          } else if (title == "修改岗位类别") {
            const res = await apiPositionTypeUpdate({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.positionTypeDialog.dialogVisible = false;
              this.getPositionTypeSearch("noRemove");
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getPositionTypeSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getPositionTypeSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getPositionTypeSearch();
    },
  },
};
</script>

<style lang="less" scoped>
</style>